module.exports = __webpack_public_path__ + "static/media/agenda-icon.2510b8d3.png";